export const eulerSwapAddresses = {
  eulerSwapV1Factory: "0x0000000000000000000000000000000000000000",
  eulerSwapV1Implementation: "0x0000000000000000000000000000000000000000",
  eulerSwapV1Periphery: "0x0000000000000000000000000000000000000000",
  eulerSwapV2Factory: "0x0000000000000000000000000000000000000000",
  eulerSwapV2Implementation: "0x0000000000000000000000000000000000000000",
  eulerSwapV2Periphery: "0x0000000000000000000000000000000000000000",
  eulerSwapV2ProtocolFeeConfig: "0x0000000000000000000000000000000000000000",
  eulerSwapV2Registry: "0x0000000000000000000000000000000000000000",
} as const
